/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubLimitSettingResponseDto } from './SubLimitSettingResponseDto';
import {
    SubLimitSettingResponseDtoFromJSON,
    SubLimitSettingResponseDtoFromJSONTyped,
    SubLimitSettingResponseDtoToJSON,
    SubLimitSettingResponseDtoToJSONTyped,
} from './SubLimitSettingResponseDto';

/**
 * 
 * @export
 * @interface LayerResponseDto
 */
export interface LayerResponseDto {
    /**
     * 
     * @type {string}
     * @memberof LayerResponseDto
     */
    layerId: string;
    /**
     * 
     * @type {number}
     * @memberof LayerResponseDto
     */
    layerNumber: number;
    /**
     * 
     * @type {string}
     * @memberof LayerResponseDto
     */
    submissionId: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResponseDto
     */
    limitType: LayerResponseDtoLimitTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LayerResponseDto
     */
    limit: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResponseDto
     */
    excess?: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResponseDto
     */
    deductibles?: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResponseDto
     */
    premium: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResponseDto
     */
    totalDeductions: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResponseDto
     */
    lineSize: string;
    /**
     * 
     * @type {Array<SubLimitSettingResponseDto>}
     * @memberof LayerResponseDto
     */
    subLimitSettings?: Array<SubLimitSettingResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof LayerResponseDto
     */
    rateAdequacy?: string;
}


/**
 * @export
 */
export const LayerResponseDtoLimitTypeEnum = {
    Primary: 'Primary',
    ExcessOfLoss: 'Excess of Loss',
    QuotaShare: 'Quota Share'
} as const;
export type LayerResponseDtoLimitTypeEnum = typeof LayerResponseDtoLimitTypeEnum[keyof typeof LayerResponseDtoLimitTypeEnum];


/**
 * Check if a given object implements the LayerResponseDto interface.
 */
export function instanceOfLayerResponseDto(value: object): value is LayerResponseDto {
    if (!('layerId' in value) || value['layerId'] === undefined) return false;
    if (!('layerNumber' in value) || value['layerNumber'] === undefined) return false;
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    if (!('limitType' in value) || value['limitType'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('premium' in value) || value['premium'] === undefined) return false;
    if (!('totalDeductions' in value) || value['totalDeductions'] === undefined) return false;
    if (!('lineSize' in value) || value['lineSize'] === undefined) return false;
    return true;
}

export function LayerResponseDtoFromJSON(json: any): LayerResponseDto {
    return LayerResponseDtoFromJSONTyped(json, false);
}

export function LayerResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LayerResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'layerId': json['layerId'],
        'layerNumber': json['layerNumber'],
        'submissionId': json['submissionId'],
        'limitType': json['limitType'],
        'limit': json['limit'],
        'excess': json['excess'] == null ? undefined : json['excess'],
        'deductibles': json['deductibles'] == null ? undefined : json['deductibles'],
        'premium': json['premium'],
        'totalDeductions': json['totalDeductions'],
        'lineSize': json['lineSize'],
        'subLimitSettings': json['subLimitSettings'] == null ? undefined : ((json['subLimitSettings'] as Array<any>).map(SubLimitSettingResponseDtoFromJSON)),
        'rateAdequacy': json['rateAdequacy'] == null ? undefined : json['rateAdequacy'],
    };
}

export function LayerResponseDtoToJSON(json: any): LayerResponseDto {
    return LayerResponseDtoToJSONTyped(json, false);
}

export function LayerResponseDtoToJSONTyped(value?: LayerResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'layerId': value['layerId'],
        'layerNumber': value['layerNumber'],
        'submissionId': value['submissionId'],
        'limitType': value['limitType'],
        'limit': value['limit'],
        'excess': value['excess'],
        'deductibles': value['deductibles'],
        'premium': value['premium'],
        'totalDeductions': value['totalDeductions'],
        'lineSize': value['lineSize'],
        'subLimitSettings': value['subLimitSettings'] == null ? undefined : ((value['subLimitSettings'] as Array<any>).map(SubLimitSettingResponseDtoToJSON)),
        'rateAdequacy': value['rateAdequacy'],
    };
}

